import { Step } from 'react-joyride';
import { SPACE_MARK } from '../../../../../constants/Consts';

export const SpaceTutorialSteps: Step[] = [
  {
    target: '#space-key',
    content: '',
    placement: 'top',
    disableBeacon: true,
    data: {
      contents: [
        {
          tutorialTxt: <><ruby>文字<rt>もじ</rt></ruby>の<ruby>間<rt>あいだ</rt></ruby>を<ruby>空<rt>あ</rt></ruby>けたいときは</>,
          style: 'tooltipText1',
        },
        {
          tutorialTxt: <>スペースキーを<ruby>押<rt>お</rt></ruby>そう！</>,
          style: 'tooltipText2',
        },
        {
          tutorialTxt: <>「{SPACE_MARK}」は、「スペース」の<ruby>印<rt>しるし</rt></ruby>だよ。</>,
          style: 'tooltipText3',
        },
      ],
      buttonLabel: 'わかった',
      displayWord: `x${SPACE_MARK}y`,
    },
  },
];